import React from 'react';

const Contuct = () => {
    return (
        <div>
            contuct
        </div>
    );
};

export default Contuct;